import { FTANode, TreeStructure } from '../../types/fta.types';
import { Edge } from 'reactflow';
import { authenticatedFetchJSON } from '../../utils/authenticatedFetch';

export const generateFTATree = async (topic: string): Promise<TreeStructure> => {
  try {
    console.log(`🎯 Generating FTA tree for topic: ${topic} via backend`);

    const data = await authenticatedFetchJSON<any>('/api/agents/fta/generate', {
      method: 'POST',
      body: JSON.stringify({ topic })
    });

    if (!data.nodes || !data.connections) {
      throw new Error("Invalid response format from AI backend");
    }

    // Transform to React Flow format
    const nodes: FTANode[] = data.nodes.map((n: any) => ({
      id: n.id,
      type: 'ftaNode',
      position: { x: 0, y: 0 },
      data: {
        label: n.label,
        type: n.type,
        description: n.description,
        probability: n.probability || undefined
      }
    }));

    const edges: Edge[] = data.connections.map((c: any, index: number) => ({
      id: `e-${index}`,
      source: c.sourceId,
      target: c.targetId,
      type: 'smoothstep',
      animated: false,
    }));

    return { nodes, edges };

  } catch (error: any) {
    console.error("Error generating FTA via backend:", error);
    throw new Error(error.message || "Failed to generate FTA via Magnus Backend");
  }
};
